import DiscountCodesPage from './discountCodes';

export default DiscountCodesPage;
